// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SessionProgressDescription_wrapper__3axHo"};